import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Cookies from "js-cookie";
import { getCompanyAllFinalQuotation } from '../../../Redux/action/Organisation/OrganisationListAction';
import Beatloader from '../../../Common/Loaders/Beatloader';

const CustomerQuotationList = ({accessedPermission}) => {

    const { b64id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;

    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        if (token && user_id) {
            if (b64id) {
                let id = atob(b64id);
                if (id) {
                    dispatch(getCompanyAllFinalQuotation(token, user_id, id));
                }
            } else {
                toast.error("Please enter correct url")
                navigate(-1);
            }
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, []);

    const {
        loadingCompanyFinalQuotationList,
        CompanyFinalQuotationList,
        CompanyFinalQuotationCompanyDetails,
        CompanyFinalQuotationListError,
    } = useSelector(state => state?.OrganisationListReducer);


    const [qList, setQList] = useState([]);
    useEffect(() => {
        if (loadingCompanyFinalQuotationList) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }

        if (CompanyFinalQuotationList) {
            setQList(CompanyFinalQuotationList);
        }
    }, [loadingCompanyFinalQuotationList, CompanyFinalQuotationList, CompanyFinalQuotationCompanyDetails])

    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <div className="page-wrapper">
                        <div className="content">
                            <div className="row">
                                <div className="col-md-12">
                                    {/* Page Header */}
                                    <div className="page-header">
                                        <div className="row align-items-center">
                                            <div className="col-8">
                                                <h4 className="page-title">
                                                    Customer Quotation <span className="count-title">{qList.length}</span>
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                    {/* /Page Header */}
                                </div>
                            </div>
                            {CompanyFinalQuotationCompanyDetails && <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-12 d-flex">
                                            <label htmlFor="form-label mx-1"><b>Company Name:</b>
                                            </label>
                                            <div className="flex mx-1">
                                                <span>{CompanyFinalQuotationCompanyDetails?.name}</span>
                                                {CompanyFinalQuotationCompanyDetails?.customerType ? <span>({CompanyFinalQuotationCompanyDetails?.customerType})</span> : null}
                                                {CompanyFinalQuotationCompanyDetails?.profileCompleted ? <span className='mx-1'><i className="fa-solid fa-circle-check" style={{ color: "#007002" }}></i></span> : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            <div className="card">
                                <div className="card-body table-responsive">
                                    {/* Filter */}
                                    {/* <div className="table-responsive"> */}
                                    <table className="table table-sm table-striped table-responsive">
                                        <thead>
                                            <tr>
                                                <th scope="col">S.No.</th>
                                                <th scope="col">Quotation No.</th>
                                                <th scope="col">Buyer Ref No.</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                qList?.length > 0 ?
                                                    qList.map((val, index) => {
                                                        return <tr>
                                                            <th scope="row">{index + 1}</th>
                                                            <td>{val?.ship_quotation_no}</td>
                                                            <td>{val?.ship_buy_ref_no}</td>
                                                            <td>
                                                                <div className="dropdown table-action" key={index + 1}>
                                                                    <Link
                                                                        to="#"
                                                                        className="action-icon"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="true"
                                                                    >
                                                                        <i className="fa fa-ellipsis-v"></i>
                                                                    </Link>
                                                                    <div
                                                                        className="dropdown-menu dropdown-menu-right"
                                                                        style={{
                                                                            position: "absolute",
                                                                            inset: "0px auto auto 0px",
                                                                            margin: "0px",
                                                                            transform: "translate3d(-99.3333px, 35.3333px, 0px)",
                                                                        }}
                                                                        data-popper-placement="bottom-start"
                                                                    >
                                                                        {
                                                                            val.has_created_job_order ?
                                                                               accessedPermission.includes("edit_job_order") && <Link to={`/flexichain/job-order/edit/${btoa(val.job_order_id)}`}
                                                                                    className="dropdown-item edit-popup"
                                                                                >
                                                                                    <i className="fa-solid fa-pen-to-square text-blue me-1"></i> Edit Job Order
                                                                                </Link>
                                                                                :
                                                                                accessedPermission.includes("create_job_order") && <Link to={`/flexichain/job-order/add?q_id=${btoa(val.id)}`}
                                                                                    className="dropdown-item edit-popup"
                                                                                >
                                                                                    <i className="fa-solid fa-bolt text-blue me-1"></i> Create Job Order
                                                                                </Link>
                                                                        }
                                                                    </div>
                                                                </div>

                                                            </td>
                                                        </tr>
                                                    })
                                                    :
                                                    <tr>
                                                        <td colSpan={4}>No data found.</td>
                                                    </tr>
                                            }
                                        </tbody>
                                    </table>

                                    {/* </div> */}

                                </div>
                            </div>
                        </div>
                    </div>
            }

        </>
    )
}

export default CustomerQuotationList